"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.yukonCities = void 0;
exports.yukonCities = [
    {
        label: "Carcross",
        value: 8237,
    },
    {
        label: "Carmacks",
        value: 8181,
    },
    {
        label: "Dawson City",
        value: 8150,
    },
    {
        label: "Faro",
        value: 8160,
    },
    {
        label: "Haines Junction",
        value: 8165,
    },
    {
        label: "Little Gold",
        value: 8399,
    },
    {
        label: "Mayo-Elsa",
        value: 8423,
    },
    {
        label: "Old Crow",
        value: 8478,
    },
    {
        label: "Other",
        value: 8199,
    },
    {
        label: "Ross River",
        value: 8182,
    },
    {
        label: "Swift River",
        value: 8170,
    },
    {
        label: "Tagish",
        value: 8151,
    },
    {
        label: "Watson Lake",
        value: 8705,
    },
    {
        label: "Whitehorse",
        value: 8180,
    },
];
